import { useEffect, useRef, useState } from 'react';
import './Header.scss';
import logo from '../assets/logos/logo-auto-systeme.webp';
import { Link, useLocation } from "react-router-dom";

const NAV_LINKS = [
  { to: '/', label: 'Accueil', title: "Aller à la page d'accueil" },
  { to: '/available-parts', label: 'Catalogue de pièces', title: 'Aller à la page Catalogue de pièces' },
  { to: '/part-search', label: 'Demander une pièce', title: 'Aller à la page Demander une pièce' },
  { to: '/car-sell', label: 'Vendez votre véhicule', title: 'Aller à la page Vendez votre véhicule' },
  { to: '/profession', label: 'Notre métier', title: 'Aller à la page Notre métier' },
];

// Pages dont le haut a un fond foncé/vert : le header s'affiche en clair par-dessus.
const LIGHT_HEADER_PATHS = ['/', '/politique-de-confidentialite'];

function prefetchContact() {
  // Précharge le chunk JS de la page Contact
  import('../Contact/Contact');
  // Précharge les images hero en les téléchargeant silencieusement via des objets Image
  // Le navigateur les met en cache : au moment du click, elles sont déjà disponibles
  Promise.all([
    import('../assets/images/shop.webp'),
    import('../assets/images/administration.webp'),
  ]).then(([{ default: shopSrc }, { default: adminSrc }]) => {
    [shopSrc, adminSrc].forEach((src) => {
      const img = new window.Image();
      img.src = src;
    });
  });
}

let contactPrefetched = false;

function handleContactPrefetch() {
  if (contactPrefetched) return;
  contactPrefetched = true;
  prefetchContact();
}

function Header() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);
  const burgerRef = useRef(null);

  const handleLinkClick = () => {
    window.scrollTo(0, 0);
    setMenuOpen(false);
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        menuOpen &&
        navRef.current &&
        !navRef.current.contains(e.target) &&
        burgerRef.current &&
        !burgerRef.current.contains(e.target)
      ) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [menuOpen]);

  const isLight = LIGHT_HEADER_PATHS.includes(location.pathname) && !menuOpen;
  // Lien actif aussi sur les sous-pages (ex : /available-parts/123)
  const isCurrentPath = (path) => location.pathname === path || location.pathname.startsWith(`${path}/`);

  return (
    <header className={`header ${isLight ? 'header--light' : ''}`}>
      <div className="header__halo header__halo--left" />
      <div className="header__halo header__halo--right" />

      <Link to="/" onClick={handleLinkClick} title="Aller à la page d'accueil" className="header__logo-wrap">
        <img src={logo} alt="Logo Auto Système" className="header__logo" />
      </Link>

      <button
        ref={burgerRef}
        className={`header__burger ${menuOpen ? 'header__burger--open' : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Ouvrir ou fermer le menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <nav ref={navRef} className={`header__nav ${menuOpen ? 'header__nav--open' : ''}`}>
        <ul>
          {NAV_LINKS.map((link) => (
            <li key={link.to}>
              <Link
                className={isCurrentPath(link.to) ? 'current-page' : ''}
                to={link.to}
                onClick={handleLinkClick}
                title={link.title}
              >
                {link.label}
              </Link>
            </li>
          ))}
          <li>
            <Link
              to="/contact"
              onClick={handleLinkClick}
              onMouseEnter={handleContactPrefetch}
              onFocus={handleContactPrefetch}
              title="Aller à la page de contact"
              className={`header__cta ${isLight ? '' : 'header__cta--solid'} ${location.pathname === '/contact' ? 'current-page' : ''}`}
            >
              Nous contacter
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
